import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
import { ref, nextTick } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'default',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const defaultModule = ref(null);
        const topPadding = ref(100);
        const bottomPadding = ref(100);
        const h2Tags = getH2Tags();
        const textBody = getTextBody();
        function getH2Tags() {
            const div = document.createElement('div');
            div.innerHTML = props.d.body;
            const replacements = [
                { find: 'a bold online presence', replace: 'Idea' },
                { find: 'a brand building exercise', replace: 'Idea' },
                { find: 'a feast of fantasy', replace: 'Process' },
                { find: 'a sprinkle of christmas magic', replace: 'Results' },
                { find: 'a view from the inside', replace: 'Process' },
                { find: 'absolute clarity', replace: 'Clarity' },
                { find: 'an online presence', replace: 'Results' },
                { find: 'art direction', replace: 'Solution' },
                { find: 'bold & confident', replace: 'Process' },
                { find: 'brand assets', replace: 'Solution' },
                { find: 'brand awareness campaign', replace: 'Solution' },
                { find: 'brand campaign', replace: 'Idea' },
                { find: 'brand development', replace: 'Idea' },
                { find: 'brand device', replace: 'Brand' },
                { find: 'brand guidelines', replace: 'Brand' },
                { find: 'brand workshop', replace: 'Brand' },
                { find: 'bright ideas', replace: 'Assets' },
                { find: 'bringing the brand to life', replace: 'Solution' },
                { find: 'burlesque supper club', replace: 'Idea' },
                { find: 'campaign photography', replace: 'Solution' },
                { find: 'campaign rollout', replace: 'Campaign' },
                { find: 'campaign toolkit', replace: 'Process' },
                { find: 'clear brand strategy', replace: 'Strategy' },
                { find: 'comfortable in all sizes', replace: 'Results' },
                { find: 'content management', replace: 'Process' },
                { find: 'corporate brochure', replace: 'Print' },
                { find: 'crowning glory', replace: 'Idea' },
                { find: 'data driven research', replace: 'Insight' },
                { find: 'deliverables', replace: 'Assets' },
                { find: 'digital application', replace: 'Digital' },
                { find: 'digital brand kit', replace: 'Design' },
                { find: 'digital character', replace: 'Solution' },
                { find: 'digital refresh', replace: 'Results' },
                { find: 'doing our research', replace: 'Insight' },
                { find: 'energy know-how', replace: 'Idea' },
                { find: 'everything packaging', replace: 'Idea' },
                { find: 'exploring our surroundings', replace: '' },
                { find: 'focus on unity', replace: 'Process' },
                { find: 'focusing on fashion', replace: 'Idea' },
                { find: 'frameworks', replace: 'Digital' },
                { find: 'generating content to tell their story', replace: 'Solution' },
                { find: 'learning for life', replace: 'Idea' },
                { find: "let's do launch", replace: 'Launch' },
                { find: 'national tour', replace: 'Tour' },
                { find: 'new brand', replace: 'Idea' },
                { find: 'nobody better', replace: 'Imagery' },
                { find: 'note below', replace: 'Solution' },
                { find: 'now brighter', replace: 'Digital' },
                { find: 'offical merchandise', replace: 'Merch' },
                { find: 'office & portrait photography', replace: 'Solution' },
                { find: 'on location', replace: 'Process' },
                { find: 'our research', replace: 'Research' },
                { find: 'packaging', replace: 'Packaging' },
                { find: 'personas and positioning', replace: 'Clarity' },
                { find: 'photography', replace: 'Planning' },
                { find: 'print and digital assets', replace: 'Digital' },
                { find: 'process & development', replace: 'Process' },
                { find: 'providing connections', replace: 'Idea' },
                { find: 'putting keoghs in control', replace: 'Control' },
                { find: 'putting their hearts into it', replace: 'Talent' },
                { find: 'research & wireframing', replace: 'Research' },
                { find: 'responsive website design', replace: 'Solution' },
                { find: 'restyling the company', replace: 'Brief' },
                { find: 'rolling out the rebrand', replace: 'Digital' },
                { find: "santa's little helpers", replace: 'Planning' },
                { find: 'sending the message', replace: '' },
                { find: 'sharing history', replace: 'History' },
                { find: 'smart communication', replace: 'Solution' },
                { find: 'stay informed', replace: 'Messaging' },
                { find: 'style guidelines', replace: '' },
                { find: 'supporting literature', replace: '' },
                { find: 'take a closer look', replace: 'Solution' },
                { find: 'taste supreme', replace: 'Taste' },
                { find: 'the animation', replace: 'Process' },
                { find: 'the challenge', replace: 'Challenge' },
                { find: 'the delivery', replace: 'Delivery' },
                { find: 'the digital experience', replace: 'Solution' },
                { find: 'the highlights', replace: 'Result' },
                { find: 'the idea', replace: 'Idea' },
                { find: 'the ideas', replace: 'Ideas' },
                { find: 'the insight', replace: 'Insight' },
                { find: 'the launch event', replace: 'Launch' },
                { find: 'the lifestyle look', replace: 'Solution' },
                { find: 'the result', replace: 'Result' },
                { find: 'the results', replace: 'Results' },
                { find: 'the strategy', replace: 'Strategy' },
                { find: 'user journey', replace: 'Digital' },
                { find: 'web design and development', replace: 'Digital' },
                { find: 'web power', replace: 'Digital' },
                { find: 'website design', replace: 'Process' },
                { find: 'website design & development', replace: 'Solution' },
                { find: 'website design and development', replace: 'Digital' },
                { find: 'wireframes', replace: 'Process' },
                { find: 'wireframes and user journeys', replace: 'Solution' },
                { find: 'working together', replace: 'Process' }
            ];
            const h2Elements = div.querySelectorAll('h2');
            const h2TagsArray = Array.from(h2Elements).map(tag => {
                let h2Tag = tag.innerHTML;
                // Replace <strong> and </strong> with an empty string
                h2Tag = h2Tag.replace(/<\/?strong>/g, '');
                // Replace &nbsp; with an empty string
                h2Tag = h2Tag.replace(/&nbsp;/g, ' ');
                // Check if the last character is a space and remove it
                if (h2Tag.charAt(h2Tag.length - 1) === ' ') {
                    h2Tag = h2Tag.slice(0, -1);
                }
                // Convert h2Tag to lowercase
                h2Tag = h2Tag.toLowerCase();
                // Find the replacement for a specific value
                const replacement = replacements.find(rep => rep.find === h2Tag);
                if (replacement && replacement.replace !== '') {
                    return replacement.replace;
                }
                // If there is no replacement and the length is less than or equals to 9 characters, return the tag with capitalised words
                if (h2Tag.length <= 9) {
                    return h2Tag.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                }
                // If there is no replacement round and is more than 9 characters long, do not display
                return null;
            }).filter(tag => tag !== null); // Filter out null values
            return h2TagsArray;
        }
        function getTextBody() {
            const div = document.createElement('div');
            div.innerHTML = props.d.body;
            const paragraphElements = div.querySelectorAll('p');
            let textBody = '';
            paragraphElements.forEach(tag => {
                textBody += tag.outerHTML; // Concatenate the entire paragraph tag
            });
            return textBody;
        }
        function bigTextBreakerData() {
            return {
                title: h2Tags[0],
                background_colour: '#fff',
                desktop_container: false
            };
        }
        function mainTextBlockData() {
            return {
                line_one: null,
                line_two: null,
                leadin: textBody
            };
        }
        function carouselData(slide) {
            // Remove all padding if there are images
            topPadding.value = 0;
            bottomPadding.value = 0;
            return {
                image_carousel_images: [
                    {
                        image: slide.path,
                        alt: slide.alt
                    }
                ],
                width: 'full-width'
            };
        }
        nextTick(() => {
            if (defaultModule.value && defaultModule.value.previousElementSibling) {
                if (defaultModule.value.previousElementSibling.classList.contains('grid') || defaultModule.value.previousElementSibling.classList.contains('images') || defaultModule.value.previousElementSibling.classList.contains('default')) {
                    topPadding.value = 50;
                }
            }
            if (defaultModule.value && defaultModule.value.nextElementSibling) {
                if (defaultModule.value.nextElementSibling.classList.contains('default') || defaultModule.value.nextElementSibling.classList.contains('grid') || defaultModule.value.nextElementSibling.classList.contains('images')) {
                    bottomPadding.value = 25;
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_big_text_breaker = _resolveComponent("big-text-breaker");
            const _component_main_text_block = _resolveComponent("main-text-block");
            const _component_image_carousel = _resolveComponent("image-carousel");
            return (!(_unref(h2Tags).length === 0 && _unref(textBody).length === 0 && __props.d.slides.length === 0))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["default", `top_spacing-` + topPadding.value + ` bottom_spacing-` + bottomPadding.value]),
                    ref_key: "defaultModule",
                    ref: defaultModule
                }, [
                    (_unref(h2Tags).length == 1)
                        ? (_openBlock(), _createBlock(_component_big_text_breaker, {
                            key: 0,
                            d: bigTextBreakerData()
                        }, null, 8, ["d"]))
                        : _createCommentVNode("", true),
                    (_unref(textBody).length > 0)
                        ? (_openBlock(), _createBlock(_component_main_text_block, {
                            key: 1,
                            class: "top_spacing-0 bottom_spacing-0 module",
                            d: mainTextBlockData()
                        }, null, 8, ["d"]))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.slides, (slide) => {
                        return (_openBlock(), _createBlock(_component_image_carousel, {
                            d: carouselData(slide)
                        }, null, 8, ["d"]));
                    }), 256))
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
